import { useEffect, useState } from 'react';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { RootColorTheme } from "src/css/rootColorTheme";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return visible ? (
    <Fab
      onClick={scrollToTop}
      size="large"
      sx={{
        backgroundColor: RootColorTheme,
        ":hover": {
          backgroundColor: RootColorTheme,
          boxShadow: 3,
          transform: 'scale(1.25)',
          transition: 'transform 0.3s ease-in-out',
        },
        position: 'fixed',
        bottom: 100, // Adjust vertical position
        right: 30,   // Adjust horizontal position
        zIndex: 1000,
        boxShadow: 3
      }}
      variant='outlined'
      aria-label="scroll back to top"
    >
      <KeyboardArrowUpIcon sx={{color: 'white'}}/>
    </Fab>
  ) : null;
}
